import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ChargingStation } from '@models/charging-station';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { FormService } from '@services/form/form.service';
import {DiagnosticsRequestDto} from '@dto/diagnosticsRequestDto';
import { ToastService } from '@services/toast/toast.service';

@Component({
  selector: 'app-diagnostics-charging-station-dialog-content',
  templateUrl: './diagnostics-charging-station-dialog-content.component.html',
  styleUrls: ['./diagnostics-charging-station-dialog-content.component.scss']
})
export class DiagnosticChargingStationDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'DiagnosticsChargingStationDialogContentComponent';
  public diagnosticsDto : DiagnosticsRequestDto
  public form: UntypedFormGroup;
  @Input() private entity: string;

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    private chargingStationsService: ChargingStationsService,
    public toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.formService.form = new UntypedFormGroup({});
  }

  onSubmit() {
    this.diagnosticsDto = null;
    this.toastService.loading($localize`:@@OpenDiagnosticsSuccess:Diagnosedaten werden abgefragt...`);
    this.chargingStationsService.posttriggerAutomaticDiagnosticUpload(this.entity).subscribe(result => {
      this.toastService.success($localize`:@@OpenDiagnosticsSuccess:Diagnosedaten erfolgreich abgefragt.`, 0, true);
      window.setTimeout(() => {
        this.toastService.info($localize`:@@OpenDiagnosticsSuccess:Die Diagnosedatei kann in wenigen Minuten über einen FTP-Zugang heruntergeladen werden.`, 0, true);
      }, 3000)
    }, error => {
      this.messageService.setError(error);
      this.toastService.error($localize`:@@OpenDiagnosticsError:Fehler beim abfragen der Diagnosedaten:`+error);
    });
    this.activeModal.close(true);
  }

}
